<template>
    <el-select v-model="values" @change="$emit('input', values)" style="width: calc(100% - 50px);"
        :placeholder="formData.placeholder">
        <el-option v-for="(selitem, selidx) in formData.options" :key="selidx" :value="selitem.label"
            :label="selitem.label"></el-option>
    </el-select>
</template>
<script>
export default {
    props: {
        formData: {
            type: Object
        },
        value: {
            type: [Number, String]
        }
    },
    watch: {
        value: {
            handler(val) {
                this.values = val;
            },
            immediate: true
        },
    },
    data() {
        return {
            values: '',
        }
    },
    methods: {
        getWidth() {
            if (this.formData.col == 24) return true;
            return false;
        }
    }
}
</script>
<style lang="scss" scoped></style>